import {
  Group
} from 'three'
import GLTFLoader from 'three-gltf-loader'

export default class Flower extends Group {
  constructor () {
    const loader = new GLTFLoader()

    super()

    this.name = 'tree'

    loader.load('/static/tree.json', (mesh) => {
      this.add(mesh.scene)
    })
  }
}
